import styled from "styled-components";
import theme from "../../Themes/light";
import fotoBackground from "../../assets/newImages/login/background.png";
import backgroundMobile from "../../assets/newImages/login/bg_mobile.png";

export const ViewLogin = styled.div`
    padding: 0 100px;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: end;
    font-family: 'Inter';
    overflow: auto;

    @media (min-width: 320px) {
        padding: 0 20px;
    }

    @media (min-width: 375px) {
        padding: 0 50px;
    }

    @media (min-width: 425px) {
        padding: 0 50px;
    }

    @media (min-width: 768px) {
        padding: 0 150px;
    }

    @media (min-width: 992px) {
        padding: 0 100px;
    }

    @media (min-width: 320px) {
        background-image: url(${backgroundMobile});
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
    }

    @media (min-width: 375px) {
        background-image: url(${backgroundMobile});
        background-size: cover;
        background-repeat: no-repeat;
    }

    @media (min-width: 425px) {
        background-image: url(${backgroundMobile});
        background-position: center bottom;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
    }

    @media (min-width: 768px) {
        background-image: url(${fotoBackground});
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
    }

    @media (min-width: 992px) {
        background-image: url(${fotoBackground});
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .login {
        display: flex;
        flex-direction: column;
        min-width: 468px;
        z-index: 2;
        @media (max-width: 425px) {
            min-width: 100%;
            height: 80%;
        }
        @media (max-width: 375px) {
            min-width: 100%;
            height: 80%;
        }


        .topo-login {
            display: grid;
            grid-template-columns: 80% 20%;
            align-items: center;
            justify-content: space-between;

            .logo {
                background-color: #eaeaeaa6;
                backdrop-filter: blur(7.5px);
                padding-left: 80px;
                width: 100%;
                height: 100%;
                border-top-left-radius: 30px;
                border-top-right-radius: 30px;

                display: flex;
                justify-content: start;
                align-items: center;
                @media (max-width: 1440px) {
                    padding-left: 80px;
                }
                @media (max-width: 1024px) {
                    padding-left: 80px;
                }
                @media (max-width: 768px) {
                    padding-left: 100px;
                }
                @media (max-width: 425px) {
                    padding-left: 30px;
                }
                @media (max-width: 375px) {
                    padding-left: 30px;
                }

                .logo-svg {
                    height: 40px;
                    @media (max-width: 1024px) {
                        width: 60%;
                    }
                    @media (max-width: 425px) {
                        width: 150px;
                    }
                    @media (max-width: 375px) {
                        width: 130px;
                    }
                }
            }

            .icone-canto {
                background-color: transparent;
                border-bottom-left-radius: 40px;
                display: flex;

                .icone {
                    width: 60px;
                    height: 60px;
                    background-color: #eaeaea80;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-left: -20px;
                    margin-top: 0px;
                    @media (max-width: 425px) {
                        width: 55px;
                        height: 55px;
                    }
                    @media (max-width: 375px) {
                        width: 50px;
                        height: 50px;
                        .img-responsive {
                            width: 50%;
                        }
                    }
                }

                &::before {
                    content: '';
                    z-index: 1;
                    background-color: transparent;
                    border-bottom-left-radius: 40px;
                    width: 32px;
                    height: 21px;
                    margin-top: 52px;
                    box-shadow: -4px 5px 0px 2px #a0b1a8;
                    @media (max-width: 768px) {
                        box-shadow: -4px 5px 0px 2px #a8beb2;
                    }
                    @media (max-width: 425px) {
                        box-shadow: -4px 5px 0px 2px #abc2b5;
                    }
                    @media (max-width: 375px) {
                        box-shadow: -4px 5px 0px 2px #a8beb2;
                        margin-top: 40px;
                    }
                }
            }
        }

        .bg-login {
            background-color: #eaeaeaa6;
            backdrop-filter: blur(7.5px);
            padding: 50px 80px;
            border-bottom-left-radius: 30px;
            border-bottom-right-radius: 30px;
            border-top-right-radius: 30px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 24px;
            @media (max-width: 768px) {
                padding: 50px 100px;
            }
            @media (max-width: 425px) {
                padding: 35px 32px;
            }
            @media (max-width: 375px) {
                padding: 15px 32px;
            }

            .texto {
                font-size: 32px;
                color: ${theme.colors.secondary};
                font-weight: 800;
                line-height: 36px;
                @media (max-width: 425px) {
                    font-size: 22px;
                    line-height: 24px;
                }
                @media (max-width: 375px) {
                    font-size: 20px;
                    line-height: 24px;
                }
            }

            span.linha {
                width: 100%;
                height: 1px;
                background-color: ${theme.colors.elements};
            }

            .frase {
                color: ${theme.colors.primary};
                text-align: center;
                font-weight: 400;
            }
        }
    }

    .login {
        .form-control {
            &:focus {
                border-color: ${theme.colors.primary};
                box-shadow: 0 0 5px ${theme.colors.primary};
            }
        }

        .input {
            background-color: transparent;
            border: 1px solid ${theme.colors.primary};
            border-radius: 40px;
            color: #626262;
            
            

            &::placeholder {
                color: #626262;
            }

            input {
                background-color: transparent;
                border-radius: 40px;
                color: #626262;

                &::placeholder {
                    color: #626262;
                }

                &:focus {
                    border: none;
                    color: #626262 !important;
                }
            }
        }

        .esqueciSenha {
            color: #626262;
            background-color: transparent;
            text-align: right;

            &:focus {
                outline: none;
            }

            &:hover {
                cursor: pointer;
            }
        }

        .login-button {
            height: auto;
            border-radius: 100px;
            background-color: ${theme.colors.secondary};
            color: ${theme.colors.white};
            width: 100%;
            font-size: 16px !important;
            letter-spacing: 0.15px;
            font-weight: 700;
            padding: 10px 0;
        }
    }
`;
